import { getCookie } from '../utils/cookies'

const DEVELOPMENT_STORAGE_API_URL =
	process.env.NEXT_PUBLIC_STORAGE_API?.trim()?.includes('localhost')
		? `http://${process.env.NEXT_PUBLIC_STORAGE_API?.trim()}`
		: `https://${process.env.NEXT_PUBLIC_STORAGE_API?.trim()}`

export const getImage = async (filename: string) => {
	const IMAGE_URL =
		process.env.NODE_ENV === 'development'
			? `${DEVELOPMENT_STORAGE_API_URL}/storage/access/`
			: window.location.protocol +
			  '//' +
			  window.location.hostname +
			  `/storage/access/`
	try {
		const token = getCookie('storage_token')

		const res = await fetch(IMAGE_URL + filename, {
			headers: {
				'Content-Type': 'application/octet-stream',
				Authorization: `Bearer ${token}`,
			},
		})
		const blob = await res.blob()

		return blob
	} catch (e) {
		console.log(e)
		return null
	}
}

export const downloadImage = async (filename: string, name: string) => {
	const IMAGE_URL =
		process.env.NODE_ENV === 'development'
			? `${DEVELOPMENT_STORAGE_API_URL}/storage/access/`
			: window.location.protocol +
			  '//' +
			  window.location.hostname +
			  `/storage/access/`
	try {
		const token = getCookie('storage_token')

		const res = await fetch(IMAGE_URL + filename, {
			headers: {
				'Content-Type': 'application/octet-stream',
				Authorization: `Bearer ${token}`,
			},
		})
		const blob = await res.blob()

		if (!res.ok) throw new Error('Failed to fetch image')

		// Create a temporary download link
		const url = URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.download = name
		document.body.appendChild(link)
		link.click()

		// Cleanup
		link.remove()
		URL.revokeObjectURL(url)
	} catch (error) {
		console.error('Download failed:', error)
	}
}

export const getVirtualStoreDevicePreview = async (
	deviceToken: string
): Promise<{ blob: Blob; lastModified: Date | null } | null> => {
	const IMAGE_URL =
		process.env.NODE_ENV === 'development'
			? `${DEVELOPMENT_STORAGE_API_URL}/storage/access/`
			: window.location.protocol +
			  '//' +
			  window.location.hostname +
			  `/storage/access/`
	try {
		const token = getCookie('storage_token')
		const res = await fetch(
			`${IMAGE_URL}${deviceToken}.jpg?folder=preview&t=${Date.now()}`,
			{
				headers: {
					'Content-Type': 'application/octet-stream',
					Authorization: `Bearer ${token}`,
				},
			}
		)
		if (!res.ok) return null
		const lastModifiedHeader = res.headers.get('Last-Modified')
		const lastModified = lastModifiedHeader
			? new Date(lastModifiedHeader)
			: null
		return {
			blob: await res.blob(),
			lastModified:
				lastModified && !Number.isNaN(lastModified.getTime())
					? lastModified
					: null,
		}
	} catch (e) {
		console.log(e)
		return null
	}
}
